// Attribution d'une voix ElevenLabs à un agent en fonction du genre déduit de son nom.

const AGENT_GENDER_BY_NAME = {
  'Agent Alpha': 'male',
  'Agent Beta': 'female',
  'Kimi': 'female',
  'Claude': 'male',
  'HF Agent': 'male',
  'Zai': 'male',
  'DeepSeek': 'male',
  'Grok': 'male',
  'ChatlyAI': 'female',
  'TchadGPT': 'male',
  'Gamma': 'female',
  'Delta': 'male',
  'Epsilon': 'male',
  'Zeta': 'female',
  'Eta': 'female',
  'Theta': 'male',
  'Iota': 'female',
  'Kappa': 'male',
  'Lambda': 'female',
  'Mu': 'male',
  'Nu': 'female',
  'Xi': 'male',
  'Omicron': 'male',
  'Pi': 'male',
  'Rho': 'male',
  'Sigma': 'male',
  'Tau': 'male',
  'Upsilon': 'male',
  'Phi': 'male',
  'Chi': 'male',
  'Psi': 'female',
  'Omega': 'male',
  'Mistral': 'male',
  'Groq': 'male',
  'Gemini': 'male',
  'Cohere': 'female',
  'Together': 'male',
  'Perplexity': 'female',
  'Jurassic': 'male',
  'Aleph Alpha': 'male',
  'Stability': 'female',
  'Replicate': 'male',
  'Fireworks': 'male',
  'Anyscale': 'male',
  'Poe': 'male',
  'Bedrock': 'male',
  'Azure': 'male',
  'DeepInfra': 'male',
  'Novita': 'female',
  'Hyperbolic': 'male',
  'Synthesizer': 'male',
  'Reader': 'female'
};

const AGENT_GENDER_BY_ID = {
  alpha: 'male',
  beta: 'female',
  kimi: 'female',
  claude: 'male',
  hf: 'male',
  zai: 'male',
  deepseek: 'male',
  grok: 'male',
  chatlyai: 'female',
  tchadgpt: 'male',
  gamma: 'female',
  delta: 'male',
  epsilon: 'male',
  zeta: 'female',
  eta: 'female',
  theta: 'male',
  iota: 'female',
  kappa: 'male',
  lambda: 'female',
  mu: 'male',
  nu: 'female',
  xi: 'male',
  omicron: 'male',
  pi: 'male',
  rho: 'male',
  sigma: 'male',
  tau: 'male',
  upsilon: 'male',
  phi: 'male',
  chi: 'male',
  psi: 'female',
  omega: 'male',
  mistral: 'male',
  groq: 'male',
  gemini: 'male',
  cohere: 'female',
  together: 'male',
  perplexity: 'female',
  jurassic: 'male',
  alephalpha: 'male',
  stability: 'female',
  replicate: 'male',
  fireworks: 'male',
  anyscale: 'male',
  poe: 'male',
  bedrock: 'male',
  azure: 'male',
  deepinfra: 'male',
  novita: 'female',
  hyperbolic: 'male',
  synthesizer: 'male',
  reader: 'female'
};

function inferGenderFromAgentName(name) {
  if (!name) return 'neutral';
  const normalized = String(name).trim();
  if (AGENT_GENDER_BY_NAME[normalized]) return AGENT_GENDER_BY_NAME[normalized];
  if (AGENT_GENDER_BY_ID[normalized.toLowerCase()]) return AGENT_GENDER_BY_ID[normalized.toLowerCase()];
  // Heuristique simple de fallback : noms finissant par a/e/i souvent féminins
  const lastChar = normalized.slice(-1).toLowerCase();
  if (['a', 'e', 'i'].includes(lastChar)) return 'female';
  return 'male';
}

function isVoiceMatchingGender(voice, gender) {
  const style = (voice.style || voice.description || '').toLowerCase();
  const name = (voice.name || '').toLowerCase();
  if (style.includes('female') || name.includes('female') || name.includes('femme')) return gender === 'female';
  if (style.includes('male') || name.includes('male') || name.includes('homme')) return gender === 'male';
  if (style.includes('neutral')) return true;
  // Fallback par liste de prénoms féminins connus chez ElevenLabs
  const femaleNames = new Set([
    'sarah', 'laura', 'alice', 'matilda', 'jessica', 'bella', 'lily', 'charlotte', 'maya', 'samantha',
    'salma', 'irène', 'koraly', 'amy', 'eve', 'nova', 'shimmer', 'fable', 'echo'
  ]);
  if (femaleNames.has(name)) return gender === 'female';
  return gender === 'male';
}

function selectVoiceForAgent(agentName, voices, voicesByLang, lang = 'fr') {
  if (!voices || voices.length === 0) return null;
  const gender = inferGenderFromAgentName(agentName);
  if (gender === 'neutral') {
    const byLang = (voicesByLang && voicesByLang[lang]) || voices;
    return byLang[agentName.length % byLang.length]?.id || voices[0]?.id;
  }
  const byLang = (voicesByLang && voicesByLang[lang]) || voices;
  const matching = byLang.filter(v => isVoiceMatchingGender(v, gender));
  if (matching.length > 0) {
    // Attribution stable par agent
    const index = agentName.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0) % matching.length;
    return matching[index]?.id;
  }
  return byLang[0]?.id || voices[0]?.id;
}

export {
  inferGenderFromAgentName,
  selectVoiceForAgent,
  isVoiceMatchingGender,
  AGENT_GENDER_BY_NAME,
  AGENT_GENDER_BY_ID
};
